import { THEME_META, type ThemeId } from './theme-meta.js';

/**
 * FR-07/FR-10 - promítne efektivní šablonu do kořenového elementu (`data-theme`, `color-scheme`
 * pro nativní prvky prohlížeče) a do `<meta name="theme-color">`. Volá se z `ThemeEffect` po
 * mountu a při každé změně efektivní šablony (předvolba, systémové nastavení).
 */
export function applyEffectiveTheme(theme: ThemeId): void {
  const root = document.documentElement;
  root.setAttribute('data-theme', theme);
  root.style.colorScheme = THEME_META[theme].colorScheme;

  const themeColorMeta = document.querySelector('meta[name="theme-color"]');
  themeColorMeta?.setAttribute('content', THEME_META[theme].themeColor);
}
